export const formatText = (text: string): string => {
  const paragraphs = text.split(/\r?\n\r?\n/).map(p =>
    `<p>${p.replace(/\r?\n/g, '<br>')}</p>`
  );

  return paragraphs.join('');
};
